import { END_POINTS } from '../helpers';
import { BodyTypeData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetBodyTypeResponse = {
  count: number;
  data: BodyTypeData[];
};

export const bodyType = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBodyType: builder.query<
      CommonResponse & { data: GetBodyTypeResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getBodyType}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteBodyType: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteBodyType}/${id}`,
        method: 'DELETE',
      }),
    }),
    getBodyTypeById: builder.query<CommonResponse & { data: BodyTypeData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getBodyTypeById}/${id}`,
        method: 'GET',
      }),
    }),

    addBodyType: builder.mutation<CommonResponse & { data: BodyTypeData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addBodyType}`,
        method: 'POST',
        body,
      }),
    }),
    updateBodyType: builder.mutation<
      CommonResponse & { data: BodyTypeData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateBodyType}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddBodyTypeMutation,
  useUpdateBodyTypeMutation,
  useLazyGetBodyTypeQuery,
  useLazyDeleteBodyTypeQuery,
  useLazyGetBodyTypeByIdQuery,
} = bodyType;
